import React from "react"
type Props = {
  classcode: string
  height: string
  width: string
}
const ClasscodeSvg = ({ classcode, height, width }: Props) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 561 363"
      width={width}
      height={height}
      className="classcode-svg"
    >
      <defs>
        <path
          d="M88.8 28.7H2.3s-4.7-6 0-10c2.6-2.1 5.7-1.9 7.9-1.2 1.4.4 2.9-.6 3.2-2 .5-2.5 2.2-5.7 6.8-7.6 4.6-1.8 7.5 1 9.2 3.9.5 1 2 .8 2.3-.2C33.2 7 38.2.9 54.8.9 76 .9 73.6 12 71.8 16.8a1 1 0 001.2 1.5c3.2-.7 9.3-1.6 12 .5 3.8 3 3.8 10 3.8 10"
          id="a"
        />
        <path
          d="M.8 36.4h110s6-7.6 0-12.7c-3.3-2.8-7.2-2.5-10-1.6-1.9.5-3.7-.8-4.1-2.6-.7-3.1-2.7-7.2-8.7-9.6-5.8-2.3-9.5 1.3-11.6 5-.7 1.2-2.6 1-3-.3C71.6 8.7 65.1 1 44 1 17.1 1 20.1 15.3 22.5 21.2c.4 1-.5 2.1-1.5 1.9-4.2-1-11.9-2-15.3.6C.8 27.5.8 36.4.8 36.4"
          id="d"
        />
        <path
          d="M103.6 22.9S44-15.7.2 8.2C-.4 68.2 66.5 79 66.5 79l60.3-14.3-23.2-42"
          id="g"
        />
        <path
          d="M72.2.6S13.1 3.1.2 40.8c51.6 62.7 135 1.6 135 1.6L72.3.6"
          id="i"
        />
        <path
          d="M74.8 87S69.6 16 20 .2c-56.4 69.8 30.4 130.3 30.4 130.3L74.8 87"
          id="k"
        />
        <path
          d="M130.1 28S38 37.3 7.8 29C2 27.6-1.4 21.3.8 15.9c1.3-3 4-5.4 10.1-7.1 7.1-2 13.3 1.5 17.2 4.9 1.7 1.4 4.2.5 4.8-1.5.9-2.7 2.9-5.6 7.4-7.2 6.8-2.5 16.4 3.2 22 7.3 1.6 1 3.6-.1 3.5-2-.3-5 1.7-11.5 14.5-9.4 12.7 2 17.9 9.4 20 14.7.8 2.1 3.5 2.9 5.3 1.5 3.2-2.5 8-4.5 13.9-1 10.6 6.4 10.6 12 10.6 12"
          id="m"
        />
        <path
          d="M16.5 43.3s56.8-56.4 110.7-40c14.6 66-56.7 93.5-56.7 93.5l-70-1.9 16-51.6"
          id="p"
        />
        <path
          d="M58.8 1.8s66-10.9 88.7 27.7C105.1 110.7.5 61 .5 61L58.7 1.8"
          id="r"
        />
        <path
          d="M.2 90S16.5 11.3 74.3.8c52.7 86.3-35 133.3-35 133.3L.3 90"
          id="t"
        />
        <path id="v" d="M286.8 170.1l-286.3.7L1 .6 286.8.2v170" />
        <path d="M.6 3.3C1.1 1.7 2.4 1 4 .7v6C2 6.3 0 5.6.6 3.2" id="z" />
        <path d="M4.2 3.3C3.8 1.7 2.4 1 1 .7v6c2-.3 4-1 3.3-3.4" id="C" />
        <path d="M.5 1.6a.8.8 0 101.7 0 .8.8 0 00-1.7 0" id="F" />
        <linearGradient x1="100%" y1="50%" x2="0%" y2="50%" id="b">
          <stop stopColor="#D4EBDE" offset="0%" />
          <stop stopColor="#B0DCDF" offset="100%" />
        </linearGradient>
        <linearGradient x1="0%" y1="50%" x2="100%" y2="50%" id="e">
          <stop stopColor="#D4EBDE" offset="0%" />
          <stop stopColor="#B0DCDF" offset="100%" />
        </linearGradient>
        <linearGradient x1="100%" y1="50%" x2="0%" y2="50%" id="n">
          <stop stopColor="#D4EBDE" offset="0%" />
          <stop stopColor="#B0DCDF" offset="100%" />
        </linearGradient>
        <linearGradient x1="0%" y1="50%" x2="100%" y2="50%" id="w">
          <stop stopColor="#D4EBDE" offset="0%" />
          <stop stopColor="#B0DCDF" offset="100%" />
        </linearGradient>
        <linearGradient x1="0%" y1="50%" x2="100%" y2="50%" id="y">
          <stop stopColor="#D4EBDE" offset="0%" />
          <stop stopColor="#B0DCDF" offset="100%" />
        </linearGradient>
        <linearGradient x1="0%" y1="50%" x2="100%" y2="50%" id="A">
          <stop stopColor="#D4EBDE" offset="0%" />
          <stop stopColor="#B0DCDF" offset="100%" />
        </linearGradient>
        <linearGradient x1="0%" y1="50%" x2="100%" y2="50%" id="D">
          <stop stopColor="#D4EBDE" offset="0%" />
          <stop stopColor="#B0DCDF" offset="100%" />
        </linearGradient>
        <linearGradient x1="-.1%" y1="50%" x2="100%" y2="50%" id="G">
          <stop stopColor="#D4EBDE" offset="0%" />
          <stop stopColor="#B0DCDF" offset="100%" />
        </linearGradient>
      </defs>
      <g fill="none" fillRule="evenodd">
        <g transform="translate(472 167)">
          <mask id="c" fill="#fff">
            <use xlinkHref="#a" />
          </mask>
          <path
            d="M88.8 28.7H2.3s-4.7-6 0-10c2.6-2.1 5.7-1.9 7.9-1.2 1.4.4 2.9-.6 3.2-2 .5-2.5 2.2-5.7 6.8-7.6 4.6-1.8 7.5 1 9.2 3.9.5 1 2 .8 2.3-.2C33.2 7 38.2.9 54.8.9 76 .9 73.6 12 71.8 16.8a1 1 0 001.2 1.5c3.2-.7 9.3-1.6 12 .5 3.8 3 3.8 10 3.8 10"
            fill="url(#b)"
            mask="url(#c)"
          />
        </g>
        <g transform="translate(20 70)">
          <mask id="f" fill="#fff">
            <use xlinkHref="#d" />
          </mask>
          <path
            d="M.8 36.4h110s6-7.6 0-12.7c-3.3-2.8-7.2-2.5-10-1.6-1.9.5-3.7-.8-4.1-2.6-.7-3.1-2.7-7.2-8.7-9.6-5.8-2.3-9.5 1.3-11.6 5-.7 1.2-2.6 1-3-.3C71.6 8.7 65.1 1 44 1 17.1 1 20.1 15.3 22.5 21.2c.4 1-.5 2.1-1.5 1.9-4.2-1-11.9-2-15.3.6C.8 27.5.8 36.4.8 36.4"
            fill="url(#e)"
            mask="url(#f)"
          />
        </g>
        <path
          d="M103.6 179.9S44 141.3.2 165.2c-.6 60 66.3 70.9 66.3 70.9l60.3-14.3-23.2-42"
          fill="#2A847F"
        />
        <g transform="translate(0 157)">
          <mask id="h" fill="#fff">
            <use xlinkHref="#g" />
          </mask>
          <path
            fill="#005C5A"
            mask="url(#h)"
            d="M39.7 70.7l46.8-23.3L33.8 24 5.9 36.6l-.6-1.4L31.9 23-.8 8.4.5 7.3 60.4 34 55.2 2 57 3l5 31.8 66.6 29.8-.6 1.4-39.6-17.7-46.6 23-2.1-.6"
          />
        </g>
        <path
          d="M107.2 213.6s-59.1 2.5-72 40.2c51.6 62.7 135 1.6 135 1.6l-63-41.8"
          fill="#FACB57"
        />
        <path
          d="M107.2 213.6s-59.1 2.5-72 40.2c51.6 62.7 135 1.6 135 1.6l-63-41.8"
          fill="#EE9E35"
        />
        <g transform="translate(35 213)">
          <mask id="j" fill="#fff">
            <use xlinkHref="#i" />
          </mask>
          <path
            fill="#FFFFFE"
            mask="url(#j)"
            d="M57 69.9l23.5-38L.3 41.6.1 40l48.7-5.8-26.1-20.3 1.8-.6L51 34l66-7.9.2 1.6-34.7 4.1L59 69.5l-2 .4"
          />
        </g>
        <path
          d="M128.8 188s-5.2-71-54.8-86.9c-56.4 69.8 30.4 130.3 30.4 130.3l24.4-43.3"
          fill="#13374D"
        />
        <g transform="translate(54 101)">
          <mask id="l" fill="#fff">
            <use xlinkHref="#k" />
          </mask>
          <path
            fill="#005C5A"
            mask="url(#l)"
            d="M-2.8 61.7V60l49 20.3-27-80 1.5-.4L40 56.5 58.8 32l.4 2-18.7 24.3 15.5 46-1.1 1.6-8-23.7-49.7-20.5"
          />
        </g>
        <g transform="translate(380 40)">
          <mask id="o" fill="#fff">
            <use xlinkHref="#m" />
          </mask>
          <path
            d="M130.1 28S38 37.3 7.8 29C2 27.6-1.4 21.3.8 15.9c1.3-3 4-5.4 10.1-7.1 7.1-2 13.3 1.5 17.2 4.9 1.7 1.4 4.2.5 4.8-1.5.9-2.7 2.9-5.6 7.4-7.2 6.8-2.5 16.4 3.2 22 7.3 1.6 1 3.6-.1 3.5-2-.3-5 1.7-11.5 14.5-9.4 12.7 2 17.9 9.4 20 14.7.8 2.1 3.5 2.9 5.3 1.5 3.2-2.5 8-4.5 13.9-1 10.6 6.4 10.6 12 10.6 12"
            fill="url(#n)"
            mask="url(#o)"
          />
        </g>
        <path
          d="M419.5 146.3s56.8-56.4 110.7-40c14.6 66-56.7 93.5-56.7 93.5l-70-1.9 16-51.6"
          fill="#1B2441"
        />
        <g transform="translate(403 103)">
          <mask id="q" fill="#fff">
            <use xlinkHref="#p" />
          </mask>
          <path
            fill="#005C5A"
            mask="url(#q)"
            d="M98 81.3L41 66.5l52.8-38.2 33.7 7.6.4-1.7-32.2-7.3 32.7-23.6-1.7-1-59.9 43.4-1.7-36.5-1.7 1.5 1.7 36.2L-1.5 95l1 1.4 39.7-28.7L96 82.6l2-1.3"
          />
        </g>
        <path
          d="M426.8 189.8s65.9-10.9 88.7 27.7c-42.4 81.2-147 31.5-147 31.5l58.3-59.2"
          fill="#FACB57"
        />
        <g transform="translate(368 188)">
          <mask id="s" fill="#fff">
            <use xlinkHref="#r" />
          </mask>
          <path
            fill="#FFFFFE"
            mask="url(#s)"
            d="M91.6 74.7L57 38.3l90.6-7.9-.1-1.7-55 4.8 24-28.5-2.1-.1-24.5 28.8-74.6 6.5.2 1.7 39.2-3.4 34.6 36.3h2.3"
          />
        </g>
        <path
          d="M387.2 147s16.3-78.6 74.1-89.1c52.7 86.3-35 133.3-35 133.3L387.3 147"
          fill="#21837F"
        />
        <g transform="translate(387 57)">
          <mask id="u" fill="#fff">
            <use xlinkHref="#t" />
          </mask>
          <path
            fill="#FFFFFE"
            mask="url(#u)"
            d="M91.2 69v-2L35.6 89 67.3-.6l-1.6-.6-22.5 63.6-21-28-.4 2.3 20.7 27.7L24.2 116l1.2 1.8 9.4-26.6L91.2 69"
          />
        </g>
        <path
          d="M426.5 260.4H108.7a5.8 5.8 0 01-5.8-5.8v-198c0-3.1 2.6-5.7 5.8-5.7h317.8c3.2 0 5.8 2.6 5.8 5.8v198c0 3.1-2.6 5.7-5.8 5.7"
          fill="#1B2441"
        />
        <path
          d="M413.6 243.9H121.4a7.8 7.8 0 01-7.7-7.8V70.6c0-4.3 3.5-7.8 7.7-7.8h292.2c4.3 0 7.8 3.5 7.8 7.8v165.5c0 4.3-3.5 7.8-7.8 7.8M103.7 256L30 306.6h472.3l-70.7-50.8-327.9.2"
          fill="#5BBDB7"
        />
        <path
          d="M341.4 297h-6.5c-.5 0-1-.4-1.3-.9l-2-4c-.5-1 .3-2.2 1.4-2.2h6.1c.6 0 1.1.3 1.4.8l2.2 4c.6 1-.2 2.3-1.3 2.3M354.8 297h-6.3c-.6 0-1-.3-1.3-.8l-2.4-4c-.6-1 .2-2.3 1.4-2.3h6c.4 0 1 .3 1.2.7l2.6 4c.7 1 0 2.4-1.3 2.4M175.2 270.5H161a.9.9 0 01-.6-1.5l2.9-2.8c.1-.2.3-.3.6-.3h13.8c.8 0 1.2.9.7 1.4l-2.4 2.9c-.2.2-.4.3-.7.3M320.5 297H196.8c-1 0-1.8-1.2-1.2-2.1l2.2-4.2c.3-.4.8-.7 1.3-.7h119.7c.6 0 1 .3 1.3.9l1.7 4.1c.4 1-.3 2-1.3 2M151.3 270.5h-14a.9.9 0 01-.6-1.6l3.5-2.8.6-.2h13.6c.8 0 1.1 1 .6 1.5l-3.1 2.9-.6.2M224.3 270.5h-14.8c-.6 0-1-.7-.7-1.3l1.6-2.8c.1-.3.4-.5.7-.5h14.3c.6 0 1 .6.8 1.2l-1.1 2.8c-.1.4-.4.6-.8.6M200.4 270.5H186a.9.9 0 01-.7-1.4l2.2-2.9c.2-.2.4-.3.7-.3h14.1c.7 0 1.1.8.7 1.3l-1.7 2.9c-.2.2-.5.4-.8.4M273 270.5h-14.5a1 1 0 01-1-1.2l.2-2.4c0-.6.5-1 1-1H273c.6 0 1 .5 1 1l.2 2.5a1 1 0 01-1 1M249.5 270.5h-15c-.5 0-1-.6-.8-1.1l1-2.9c0-.3.4-.6.8-.6h14.4c.6 0 1 .5.9 1l-.5 2.9c0 .4-.4.7-.8.7M165.1 282.3h-16.2a.9.9 0 01-.6-1.5l4-3.9.6-.2h15.5c.8 0 1.2.8.7 1.4l-3.3 3.9c-.2.2-.4.3-.7.3M138.6 282.3h-16a.9.9 0 01-.5-1.6l4.8-3.8c.2-.2.4-.2.6-.2h15.2c.8 0 1.2 1 .6 1.5l-4.1 3.8-.6.3M219.6 282.3H203c-.7 0-1.1-.7-.8-1.3l2.2-3.9c.1-.3.4-.4.7-.4h16c.6 0 1 .6.8 1.2l-1.5 3.8c-.1.4-.5.6-.8.6M193.1 282.3h-16.4a.9.9 0 01-.7-1.4l3-3.9c.2-.2.4-.3.7-.3h15.8c.7 0 1.1.7.7 1.3l-2.4 3.9c-.1.2-.4.4-.7.4M273.7 282.3h-16.3a1 1 0 01-1.1-1.2l.3-3.5c0-.5.5-1 1.1-1h15.8c.6 0 1 .5 1 1l.3 3.5a1 1 0 01-1 1.2M247.5 282.3h-16.7c-.6 0-1-.6-.9-1.2l1.3-3.8c.1-.4.4-.6.8-.6h16.2c.5 0 .9.5.8 1l-.6 3.8c0 .5-.5.8-.9.8M356.7 270.5H371c.8 0 1.1-1 .6-1.5l-2.9-2.8a.9.9 0 00-.6-.3h-13.9a.9.9 0 00-.6 1.4l2.4 2.9c.2.2.4.3.7.3M380.6 270.5h14c.8 0 1.2-1 .6-1.6l-3.5-2.8a.9.9 0 00-.6-.2h-13.6a.9.9 0 00-.6 1.5l3 2.9.7.2M307.6 270.5h14.7c.7 0 1.1-.7.8-1.3l-1.6-2.8a.9.9 0 00-.7-.5h-14.4c-.6 0-1 .6-.8 1.2l1.2 2.8c.1.4.4.6.8.6M331.4 270.5H346c.7 0 1.1-.8.7-1.4l-2.2-2.9a.9.9 0 00-.7-.3h-14.1c-.7 0-1.1.8-.8 1.3l1.8 2.9c.2.2.4.4.7.4M282.4 270.5h15c.5 0 1-.6.7-1.1l-.9-2.9a.9.9 0 00-.8-.6H282c-.5 0-.9.5-.8 1l.5 2.9c0 .4.4.7.8.7M366.8 282.3h16.1c.8 0 1.2-1 .6-1.5l-3.9-3.9a.9.9 0 00-.6-.2h-15.5a.9.9 0 00-.7 1.4l3.3 3.9c.2.2.4.3.7.3M393.3 282.3h15.9c.8 0 1.2-1 .5-1.6L405 277a.9.9 0 00-.6-.2h-15.3a.9.9 0 00-.6 1.5l4.2 3.8.6.3M312.3 282.3h16.6c.7 0 1-.7.8-1.3l-2.2-3.9a.9.9 0 00-.8-.4h-16c-.6 0-1 .6-.8 1.2l1.6 3.8c.1.4.4.6.8.6M338.8 282.3h16.4c.7 0 1.1-.9.7-1.4l-3-3.9a.9.9 0 00-.7-.3h-15.8c-.7 0-1.1.7-.8 1.3l2.4 3.9c.2.2.5.4.8.4M284.4 282.3H301c.6 0 1-.6.8-1.2l-1.2-3.8a.9.9 0 00-.8-.6h-16.2c-.5 0-1 .5-.8 1l.6 3.8c0 .5.4.8.9.8"
          fill="#FFFFFE"
        />
        <path
          d="M486.3 322.5H46a16 16 0 01-16-16h472.3a16 16 0 01-16 16"
          fill="#1B2441"
        />
        <g transform="translate(123 68)">
          <mask id="x" fill="#fff">
            <use xlinkHref="#v" />
          </mask>
          <path
            fill="url(#w)"
            mask="url(#x)"
            d="M286.8 170.1l-286.3.7L1 .6 286.8.2v170"
          />
        </g>
        <path fill="#FACB57" d="M410 90.2V67.6L123.9 67v23.1H410" />
        <path
          d="M384 78.5c-.3 3 1.8 5.4 4.8 5.4s5.7-2.5 6-5.6c.4-3-1.7-5.4-4.7-5.4s-5.7 2.5-6 5.6"
          fill="#FFFFFE"
        />
        <path
          d="M368.5 78.6c-.4 3 1.8 5.5 4.7 5.5 3 0 5.7-2.6 6.1-5.6.4-3-1.7-5.5-4.7-5.4-3 0-5.7 2.5-6 5.5"
          fill="#1B2441"
        />
        <path
          d="M442.3 127a11.6 11.6 0 11-23.2 0 11.6 11.6 0 0123.2 0"
          fill="#FACB57"
        />
        <path
          d="M425 128.6h12.4s-1.3 6-6.3 6-6.1-6-6.1-6M436.4 124v-.4a1 1 0 10-2 .3h2M428 124v-.4a1 1 0 10-2 .3h2"
          fill="#FFFFFE"
        />
        <path
          d="M457.3 206.6h7.1s-.5-2.2-.3-4c0-.5.4-1.1 1-1.4 7-4.4 5.2-9.4 5.2-9.4s-.7-6.3-9.7-6.9c-9.6-.6-9 8-9 8s-.4 4.6 4.6 7.8c.7.5 1.2 1.3 1.3 2.1.3 2.1-.2 3.8-.2 3.8"
          fill="#EE9E35"
        />
        <path
          d="M464.4 206.5v2.6c0 1-.6 1.7-1.4 1.7h-4.3c-.8 0-1.4-.7-1.4-1.7v-2.6h7.1"
          fill="#5BBDB7"
        />
        <path fill="#83C8B8" d="M462.6 210.8l-.5 1.2h-2.7l-.6-1.2h3.8" />
        <path
          d="M464 195c-.6 1-1.4 1.1-2.4 1v-1.5c0-.3.1-.6.3-.8.4-.3 1-.7 1.9-.3.5.3.5 1.1.2 1.7zm-4.4.6c-.7-.2-1.7-.7-1.8-1.4 0-.1 0-.3.2-.4 1.2-1.1 1.6.8 1.6 1v.8zm4.8-.4c1-2-1.6-3-2.9-1.6-.2.2-.3.5-.3.9v1.5l-1.1-.2a5 5 0 00-.2-1.7c-.7-2.2-3.6-.5-1.9 1 .4.4 1 .7 1.6 1l.1 10.4h.5v-6.4l-.1-3.4v-.5l1 .1.1 10.2h.5v-10.1h.2c1 0 2-.4 2.5-1.2z"
          fill="#FAD473"
        />
        <path
          d="M451.5 183.2v-.5l-3.6-3.6a.4.4 0 10-.5.5l3.5 3.6c.2.2.4.2.6 0M467.4 183.1a.4.4 0 010-.5l3.5-3.6c.2-.2.4-.2.6 0v.5l-3.6 3.6c-.1.2-.4.2-.5 0M460.6 181.8c.2 0 .3-.1.3-.3v-5.1a.4.4 0 10-.8 0v5c0 .3.2.4.5.4"
          fill="#EE9E35"
        />
        <path
          d="M502.5 314.4l12.9-2c1.7 0 3.7.1 4.2 1.6 0 0 .4 1 .5 1.9-.4.6-17.5 2.6-17.5 2.6-2.2-2 0-4.1 0-4.1"
          fill="#13374D"
        />
        <path
          fill="#FFFFFE"
          d="M520.1 315.9l-17.5 2.6.3.6 17.3-2.6v-.6M507.6 313.6l1.2-.2-.2 1.7-1 .1v-1.6M510 313.2l1.3-.1-.2 1.6-1 .2v-1.7"
        />
        <path
          d="M501 310.2l1.5 4.2c1.1.4 2.5.2 3.5-.5h.2v-4.4l-5.2.7"
          fill="#F0AB85"
        />
        <path
          d="M543.3 307.7l2.4-12.8c.5-1.7 1.4-3.5 3-3.5 0 0 1 0 1.9.2.4.5-3.4 17.3-3.4 17.3v.1c-2.6 1.4-3.9-1.3-3.9-1.3"
          fill="#13374D"
        />
        <path
          fill="#FFFFFE"
          d="M550.6 291.6l-3.4 17.3h.7l3.3-17.2-.6-.1M544.3 302.6l.2-1.1 1.5.6-.2 1.1-1.5-.6M544.7 300.1l.3-1.1 1.5.6-.2 1.2-1.6-.7"
        />
        <path
          d="M538.9 307.7h4.4c.7-1 1-2.3.8-3.4v-.3l-4.2-1.4-1 5.1"
          fill="#F0AB85"
        />
        <path
          d="M464.3 301.4s14 4.7 34.5 3.4c3.4-.2 6.8.3 10 1.4 12.4 4.3 30.8 2 30.8 2l1.3-5.7-61.3-16-15.3 14.9"
          fill="#005C5A"
        />
        <path fill="#EC967C" d="M457 238.1l-2.5 6 5 1.5 2-4.8-4.5-2.7" />
        <path
          d="M457.6 227.6l-1.5 8.1c.8.2 1 1.1.7 1.8v.7a9.4 9.4 0 006.7 3.3c5.3.3 4.6-10.2 4.6-10.2l-10.5-3.7"
          fill="#F0AB85"
        />
        <path
          d="M453.7 233a5 5 0 00-.8-2.5c-2.2-3.2.8-4.3 1.8-4.7 1.2-.4 1.4-2.3 3-3 2.3-1 3.8 1 5.1 1 1.4.2 2.6-1.3 4.2 0 1.6 1.4 1 2.8 1.5 3.5.4.8 2-.7 3.3 1.7 2 3.6-3.7 3.5-3.7 3.5s-3.2.6-6.7-2c-.5-.3-1.2-.3-1.6 0-1.2 1.1-2.9 7.8-2.9 7.8l-1-1.4s-2.7-1.2-2.2-3.9"
          fill="#1B2441"
        />
        <path
          d="M456.5 234.4a1.3 1.3 0 102.5-.4 1.3 1.3 0 00-2.5.4"
          fill="#F0AB85"
        />
        <path
          d="M443.9 283.7s1.5 16.5 16.4 17.7c14.9 1.2 33.1-15.1 33.1-15.1l7.3 24.9 5.8-.9s2.6-36.8-5.3-39c-8-2.3-38.2 9.5-38.2 9.5l-19.1 3"
          fill="#21837F"
        />
        <path
          d="M443.9 283.7l24.5-3.7s-1.6-5.4-2-11c-.2-4.2 1.4-8 1.4-8-1.3-9.4-4.7-18.5-13-17.5-14.2 3.5-10.9 40.2-10.9 40.2"
          fill="#1B2441"
        />
        <path
          fill="#83C8B8"
          d="M512.4 249l-8.5 21.6-21.6-2.6-.2 1.8 23 2.7 9-23-1.7-.6"
        />
        <path
          d="M458 262.3l9.8-1.5 1 10.8 17-5.3 3.8-2.5c1-.7 2.2-1 3.4-.8l4.7.7c.4 0 .8.4.9 1l1.7 5s-1.1.8-3-3.5c-.8 5-7.8 1.7-7.8 1.7l-2.4 1.7s-18.3 13.5-22.9 11c-4.6-2.5-6.1-18.3-6.1-18.3"
          fill="#F0AB85"
        />
        <path
          d="M498.6 264.6c0-.5-.5-.8-1-1l-4.6-.6c-1.2-.2-2.4.1-3.4.8l-3.7 2.5-.6.2.6 4 1.2-1 2.4-1.6s7 3.3 7.9-1.7c1.8 4.3 2.9 3.4 2.9 3.4l-1.7-5"
          fill="#F0AB85"
        />
        <path
          d="M134.2 230.8h3.6c3.3 0 6.2 2 7.6 5l3.3 7.5-7 3.4 2.3 1.5 1.2 11.5-25.6-.4-1-28.7 15.5.4.1-.2"
          fill="#5BBDB7"
        />
        <path
          d="M131.4 225s.3 3.5.8 5c.4 1 2 .8 2 .8s-1.2 5.5-5.8 5.5-5.3-4.7-5.3-4.7l3.3-.5-1.5-5 6.5-1"
          fill="#EC967C"
        />
        <path
          d="M133.3 217.4l-1-6.2-10.7 4.8.6 3.6s.8 8.8 6.5 7.7c6.2-1.1 4.9-10 4.6-10M148.7 243.3l1.5 5.2c1 3.7 0 7.7-3 10.3l-6.5 5.5-2-6.1 3.5-3.6c1.2-1.2 1.6-3 1-4.6l-1.4-3.3 7-3.4M113.8 244.7l-.8 2.5a13 13 0 003 13l4 4.1 2-9.8-5.7-9.8h-2.5"
          fill="#F0AB85"
        />
        <path fill="#5BBDB7" d="M113 247.2l3.6 2 .6-5.9H114l-1 3.9" />
        <path
          d="M122.2 220c6.9 1.4 10.7-6.2 10.7-6.2s-.2 1.6.5 4c2.3-3 .8-6.9.8-6.9s-1.9-4-10.2-2c-9.7 2.3-11.3 15.6-11.3 15.6s-.7 3 1.8 7.6c.7 1.3.6 3-.3 4.1-2 2.7-1.5 6-1.5 6s.2 1.8 1.7 3c1.3 1 2 3.3 1.3 5-1.1 3.5-.1 5.6-.1 5.6s.6 2.2 4.2 2.4c5.2.2 5-4 4.6-6.3-.2-.8 0-1.8.6-2.4.7-.7 1.4-1.8 1.4-3.3a8 8 0 00-1-3.7c-.7-1.4-.6-3 .3-4.3 1.4-1.8 3-5.4 2.1-7.7-1.6-4-4.4-5.3-5.6-10.5"
          fill="#FACB57"
        />
        <path
          fill="url(#y)"
          d="M118.6 225.9h26v-15.6h-26z"
          transform="translate(0 40)"
        />
        <path fill="#BAA6B7" d="M118.6 266.5h26v-1.3h-26z" />
        <path d="M130.6 256.7a1 1 0 102 0 1 1 0 00-2 0" fill="#FFFFFE" />
        <path
          d="M163.2 261.7c3.3 10-41 14.6-41 14.6l-1-5.7s38.6-19 42-8.9"
          fill="#1B2441"
        />
        <path fill="#F0AB85" d="M119.5 276.2l-6.4.4-1.2-1.3.6-2.4 6-.9 1 4.2" />
        <path
          d="M113.1 272.8l-6.4-.8s-2.5-.6-4.8-.3v6c1.7.1 3.4-.1 3.4-.1l7.8-1v-.1c-.8-1.1-.7-2.6 0-3.7"
          fill="#21837F"
        />
        <g transform="translate(98 271)">
          <mask id="B" fill="#fff">
            <use xlinkHref="#z" />
          </mask>
          <path
            d="M.6 3.3C1.1 1.7 2.4 1 4 .7v6C2 6.3 0 5.6.6 3.2"
            fill="url(#A)"
            mask="url(#B)"
          />
        </g>
        <path d="M109.6 273.2v2.6" fill="#F0AB85" />
        <path fill="#FFFFFE" d="M109.3 275.8h.7v-2.6h-.7z" />
        <path d="M108 273.2v2.6" fill="#F0AB85" />
        <path fill="#FFFFFE" d="M107.7 275.8h.7v-2.6h-.7z" />
        <path fill="#5BBDB7" d="M121.1 269.7l1.2 7.3-2.8.6-1.4-7 3-.9" />
        <path
          d="M133.3 217.6c-.3.8-.1 1.5.4 1.7.5.2 1-.2 1.4-1 .3-.7 0-1.5-.4-1.7-.5-.2-1.1.3-1.4 1"
          fill="#F0AB85"
        />
        <path
          d="M98.7 261.7c-3.3 10 41 14.6 41 14.6l1-5.7s-38.7-19-42-8.9"
          fill="#1B2441"
        />
        <path fill="#F0AB85" d="M142.4 276.2l6.3.4 1.2-1.3-.6-2.4-6-.9-1 4.2" />
        <path
          d="M160 271.7c-2.3-.3-4.8.3-4.8.3l-6.5.8c.8 1 .8 2.6.1 3.7v.1l7.8 1s1.7.2 3.4 0v-5.9"
          fill="#21837F"
        />
        <g transform="translate(159 271)">
          <mask id="E" fill="#fff">
            <use xlinkHref="#C" />
          </mask>
          <path
            d="M4.2 3.3C3.8 1.7 2.4 1 1 .7v6c2-.3 4-1 3.3-3.4"
            fill="url(#D)"
            mask="url(#E)"
          />
        </g>
        <path d="M152.2 273.2v2.6" fill="#F0AB85" />
        <path fill="#FFFFFE" d="M152 275.8h.6v-2.6h-.7z" />
        <path d="M153.8 273.2v2.6" fill="#F0AB85" />
        <path fill="#FFFFFE" d="M153.5 275.8h.7v-2.6h-.7z" />
        <path fill="#5BBDB7" d="M140.8 269.7l-1.2 7.3 2.8.6 1.4-7-3-.9" />
        <path fill="#AD6044" d="M72.3 172.4l7 13.2-7.7-.4-.5-13.2 1.2.4" />
        <path fill="#FFFFFE" d="M61.3 166.5h6.5l2.7 41.9H58.9l2.4-41.9" />
        <path
          d="M49.5 289.4s-1.6 1.2-1.4 2.8l.8 5.4h1.6V294c0-.2 3.5 3.5 4 3.5h8.8s.6-2.4-4.6-3.1c-5-.8-9.2-5.1-9.2-5.1"
          fill="#13374D"
        />
        <path
          d="M53.2 287.8l1.2 3a4 4 0 001.6 2c.8.6 2.1 1.4 4 2-2.3 2-6-.2-8.2-1.6-1-.8-1.8-1.9-2.1-3.1l-.5-2.3h4"
          fill="#AD6044"
        />
        <path
          d="M66 289.4s-1.6 1.2-1.3 2.8l.7 5.4h1.7V294c0-.2 3.5 3.5 4 3.5H80s.5-2.4-4.6-3.1c-5-.8-9.3-5.1-9.3-5.1"
          fill="#13374D"
        />
        <path
          d="M69.8 287.8l1.2 3a4 4 0 001.6 2c.8.6 2.1 1.4 4 2-2.3 2-6-.2-8.2-1.6-1-.8-1.8-1.9-2.1-3.1l-.5-2.3h4"
          fill="#AD6044"
        />
        <path
          d="M56.4 208.4s-1.1 6.2 5.1 37c-5 16 3 42.8 3 42.8h6l4-79.8H56.4"
          fill="#21837F"
        />
        <path
          d="M67.1 166.5l2.1 50.8 7-3s-3.2-9.5-2.9-22.7c-1-9.6 4.4-4.6-2.3-23-2.4-2-3.9-2-3.9-2"
          fill="#FAD473"
        />
        <path
          d="M68 161.3l-.8 4.3a2.7 2.7 0 01-4.1 1.8l-2.9-1.8 5.1-11.5 2.7 7.2"
          fill="#AD6044"
        />
        <path
          d="M50.7 208.4s-7.8 6.2-1.5 37c-5 16-.6 42.8-.6 42.8h5.3l15-79.8H50.6"
          fill="#5BBDB7"
        />
        <path
          d="M61.3 162.2s-6.5 3.7-8.5 7c-2 3.1-2.6 10.2-2.8 16.6-.3 8.7-4.5 31.5-4.5 31.5H63l.5-49.7-2.2-5.4"
          fill="#FAD473"
        />
        <path
          d="M74.2 148.4c-4-1-7.7 3.1-7.7 3.1l-3 16-4.6-7s-.3-9.6 4.2-16c3.1-3.8 9.2-2.7 12.3 1 1.5 1.9 1.8 4.4 1.7 6.7l-1.1 21-9-6.8s.1-1.8 1-5.1c1.5-5.7 8.9-12.2 6.2-12.9"
          fill="#1B2441"
        />
        <path
          d="M65.3 151.3c.6-.3 1.3.1 1.7.8.3.8.1 1.5-.5 1.8-.5.2-1.3-.2-1.7-.9-.3-.7-.1-1.5.5-1.7"
          fill="#AD6044"
        />
        <path
          d="M69.5 162c.8.3 1.5.5 2 .3 3.4-2.5 4.7-12.5 4.7-12.5l-2.8-2.9-5.4 1.2-2.7 6c-.7 1.5-.6 3.4.2 4.9 1 1.4 2.4 2.5 4 3"
          fill="#AD6044"
        />
        <path
          d="M75.1 148.2c-.2 3-8.6 3.3-8.6 3.3l-.5-4 5-2.8 3.8 2.4s.4.6.3 1.1"
          fill="#1B2441"
        />
        <path
          d="M75 148.8c-.3 1.1.8 3.1.8 3.1l.7-1.2v-1l-.7-.9s-.6-1.1-.8 0"
          fill="#1B2441"
        />
        <path
          d="M54.6 169.2c-8.5 1-4.5 22.8-2.7 31.8a3.8 3.8 0 004.9 3c7.3-2.4 18.1-12 18.1-12l-1.7-2.2L59 193s5.5-25-4.3-24"
          fill="#AD6044"
        />
        <path
          d="M71.5 184.6l-2.7 17.2c-.1.5.3 1 .8 1h11c.3 0 .7-.4.7-.8L84 185c.1-.5-.3-1-.8-1H72.3c-.4 0-.7.3-.8.7"
          fill="#FFFFFE"
        />
        <path
          d="M83.7 192.2l-.2-2.2c-.3-1.6-.2-4.2-1.9-2.9-1.5 2-1.7 4-1.7 4-.3 1.2.4 2.8 1 3.7l1.2 2.4s2-2.2 1.6-5"
          fill="#AD6044"
        />
        <g transform="translate(76 189)">
          <mask id="H" fill="#fff">
            <use xlinkHref="#F" />
          </mask>
          <path
            d="M.5 1.6a.8.8 0 101.7 0 .8.8 0 00-1.7 0"
            fill="url(#G)"
            mask="url(#H)"
          />
        </g>
        <path
          d="M38 148.4c3-.5 4.4 1.3 4.8 2 .4-.7 1.8-2.5 5-2 4.3.8 3.7 5.1 3.7 5.1s.5 3.5-8 8l-.6.4h-.1l-.7-.4c-8.5-4.5-8-8-8-8s-.6-4.3 3.8-5"
          fill="#EE9E35"
        />
        <path
          d="M43 150.2c.4-.7 1.9-2.3 4.7-1.7 4 .8 3.8 5 3.8 5s.5 3.5-8 8l-.6.4v-11.7M32.4 131.4c1.9-.4 2.7.8 3 1.1.2-.3 1-1.5 3-1.1 2.6.4 2.2 3.1 2.2 3.1s.4 2.1-4.8 4.9l-.4.2-.5-.2c-5.2-2.8-4.8-4.9-4.8-4.9s-.4-2.6 2.3-3.1"
          fill="#EE9E35"
        />
        <path
          d="M35.4 132.5c.3-.5 1.2-1.4 3-1 2.4.4 2.2 3 2.2 3s.4 2.1-4.8 5l-.4.1v-7.1M44 115.2c1.5-.2 2.1.6 2.3.9.2-.3.8-1.1 2.2-.9 2 .3 1.7 2.3 1.7 2.3s.2 1.6-3.6 3.6l-.3.2-.3-.2c-3.8-2-3.6-3.6-3.6-3.6s-.3-2 1.7-2.3"
          fill="#EE9E35"
        />
        <path
          d="M46.4 116c.2-.3.8-1 2.1-.8 1.8.4 1.7 2.3 1.7 2.3s.2 1.6-3.6 3.6l-.2.2V116"
          fill="#EE9E35"
        />
        <path d="M397.2 49.5v2.7M398.9 49.5v2.7" fill="#F0AB85" />
        <text
          fontFamily="Monaco"
          fontSize={getClassroomCodeFontSize(classcode)}
          letterSpacing="1.1"
          fill="#13374D"
          dominantBaseline="middle"
          textAnchor="middle"
        >
          <tspan x="48%" y="46%">
            {classcode}
          </tspan>
        </text>
      </g>
    </svg>
  )
}

const getClassroomCodeFontSize = (classroomCode: string) => {
  const baseLine = 60
  const overflown = classroomCode.length - 7
  return baseLine - overflown * 5
}

export default ClasscodeSvg
